module.exports = __webpack_public_path__ + "img/Artificial.c768aa2b.png";